import React from 'react';
import { Card, Row, Col, Tooltip, Button, QRCode, message } from 'antd';
// import { socialMediaIcons } from '../../icons/socialMedia';
import facebook from '../../images/social-media/facebook.svg'
import instagram from '../../images/social-media/instagram.svg'
import linkedinin from '../../images/social-media/linkedin.svg'
import pinterest from '../../images/social-media/pinterest.svg'
import snapchat from '../../images/social-media/snapchat.svg'
import tiktok from '../../images/social-media/tiktok.svg'
import twitter from '../../images/social-media/twitter.svg'
import whatsapp from '../../images/social-media/whatsapp.svg'
import youtube from '../../images/social-media/youtube.svg'
import { CopyFilled } from '@ant-design/icons';

const socialMediaIcon = [
  { src: instagram, alt: 'Instagram', key: 'instagram' },
  { src: facebook, alt: 'Facebook', key: 'facebook' },
  // { src: youtube, alt: 'YouTube', key: 'youtube' },
  // { src: snapchat, alt: 'Snapchat', key: 'snapchat' },
  { src: whatsapp, alt: 'WhatsApp', key: 'whatsapp' },
  { src: linkedinin, alt: 'LinkedIn', key: 'linkedin' },
  { src: twitter, alt: 'Twitter', key: 'twitter' },
  // { src: pinterest, alt: 'Pinterest', key: 'pinterest' },
  // { src: tiktok, alt: 'TikTok', key: 'tiktok' },
];



const MyCard = ({ data, key, userRole, topTitle, isRefer, extraTitle=false, isPersonalBusiness, userData, showQr }: any) => {
  const businessCode = data?.business?.businessCode;
  let refCode = userRole === 3 ? userData?.referrerCode : userData?.businessCode;
  let url = data?.business?.BusinessDetails?.url;
  const link = isPersonalBusiness ?  url : `${url}/refer/${refCode}`;
  const text = 'Become Referrer';
  const image = data?.business?.BusinessDetails;

  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;
  const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(link)}&text=${encodeURIComponent(text)}`;
  const linkedinShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}`;
  const pinterestShareUrl = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(link)}&media=${encodeURIComponent(image)}&description=${encodeURIComponent(text)}`;
  const youtubeShareUrl = `https://www.youtube.com/share?url=${encodeURIComponent(link)}`;
  const whatsappShareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}%20${encodeURIComponent(link)}`;
  const instagramShareUrl = `https://www.instagram.com/`; // No direct share link
  const snapchatUrl = `https://www.snapchat.com/`;
  const tiktokUrl = `https://www.tiktok.com/`

  const findSocialMediaUrl =(key: string)=> {
    switch (key) {
        case 'facebook': {
            return facebookShareUrl
        }
        case 'instagram': {
            return instagramShareUrl
        }
        case 'youtube': {
            return youtubeShareUrl
        }
        case 'snapchat': {
            return snapchatUrl
        }
        case 'whatsapp': {
            return whatsappShareUrl
        }
        case 'linkedin': {
            return linkedinShareUrl
        }
        case 'twitter': {
            return twitterShareUrl
        }
        case 'pinterest': {
            return pinterestShareUrl
        }
        case 'tiktok': {
            return tiktokUrl
        }
        default:
            return null
    }
  }


  const copyToClipboard = (text:string, value: string) => {
    navigator.clipboard.writeText(value);
    message.success(`${text} copied successfully!`)
  };

  return (
    <Card key={key} style={{ textAlign: 'center', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
      <Row>
        <h3 style={{ paddingLeft: '15px' }}>{(isRefer || key === 0) ? topTitle : ''}</h3>
      </Row>
      <Row gutter={[5, 5]} justify={!showQr ? "start" : "center"} style={{ marginBottom: 20 }}>
        <Col lg={10}>
          <div className='iconWrapper'>
              {socialMediaIcon.map((icon, index) => (
                  <Tooltip title={icon.alt} key={index}>
                    <a href={findSocialMediaUrl(icon?.key)} target='_blank' rel="noopener noreferrer">
                        <div className="socialMediaicons">
                          <img src={icon.src} style={{ height: '35px', width: '35px' }} />
                        </div>
                    </a>
                  </Tooltip>
              ))}
          </div>
        </Col>
        {showQr &&  <Col lg={5}>
          <div>
          <QRCode value={link} />
          </div>
        </Col>}
        <Col lg={!showQr ? 12 : 9}>
          <div style={{ marginLeft: 20, textAlign: 'left' }}>
            <div>
              {extraTitle ? <h4>ReferUs Promotional Page, copy this link and paste it to your networks to get rewarded</h4> : ''}
              {!extraTitle ? <h4>{data?.business?.BusinessDetails?.businessName}</h4> : ''}
            </div>
            <div className='text-break'>
              <a href={link} target="_blank" rel="noopener noreferrer">{link}</a>
              <Tooltip title="Copy">
                <CopyFilled onClick={()=>copyToClipboard('Link', link)} style={{ marginLeft: 10 }}  />
              </Tooltip>
            </div>
            {/* <div
            style={{ marginTop: 10 }}
            >
              <span>{businessCode}</span>
              <Tooltip title="Copy">
                <CopyFilled onClick={() => copyToClipboard('Business Code', businessCode)} style={{ marginLeft: 10 }} />
              </Tooltip>
            </div> */}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default MyCard;
